import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import PrivacyPolicy from "./pages/Guidelines/PrivacyPolicy";
import TermsConditions from "./pages/Guidelines/TermsConditions";
import CopyrightNotification from "./pages/Guidelines/CopyrightNotification";
import LoginPopUp from "./pages/LoginSignup/LoginPopUp";
// import Bankdetails from './pages/LoginSignup/Bankdetails';
import ResetPassWord from "./pages/LoginSignup/ResetPassWord";
import ResetPassWordEmail from "./pages/LoginSignup/ResetPasswordEmail";
import AuthPage from "./pages/LoginSignup/AuthPage";
import CreateCourseInfo from "./pages/Course/CreateCourse/CreateCourseInfo";
import Layout from "./components/shared/Layout";
import CourseDescriptionForm from "./pages/Course/CreateCourse/CreateCoursePages/CourseDescriptionForm";
import CourseContent from "./pages/Course/CreateCourse/CreateCoursePages/CourseContent";
import CourseLandingPage from "./pages/Course/CreateCourse/CreateCoursePages/CourseLandingPage";
import CoursePrice from "./pages/Course/CreateCourse/CreateCoursePages/CoursePrice";
import OpenCourse from "./pages/Course/OpenCourse/OpenCourse";
import CreateCoursePreview from "./pages/Course/CreateCourse/CreateCoursePreview";
import QuestionCouseInfo from "./pages/QuestionPaper/CreateQuestion/QuestionCouseInfo";
import QuestionForm from "./pages/QuestionPaper/CreateQuestion/QuestionForm";
// import QuestionPaperPreview from './pages/QuestionPaper/QuestionPaperPreview';
import Notification from "./pages/Notification/Notification";
import Wishlist from "./pages/Wishlist/Wishlist";
import Cart from "./pages/Cart/Cart";
import Course from "./pages/Course/Course";
import QRCodeScanner from "./pages/QRCodeScanner/QRCodeScanner";
import EditProfile from "./pages/Edit Profile/EditProfile";
import Profile from "./pages/Profile/Profile";
import CourseVideoTest from "./pages/Course/CreateCourse/CreateCoursePages/CourseVideoTest";
import AdminHome from "./pages/Admin/AdminHome";
import AdminStudents from "./pages/Admin/AdminStudents";
import AdminTeacher from "./pages/Admin/AdminTeacher";
import AdminBillig from "./pages/Admin/AdminBillig";
import QuestionFormPreview from "./pages/QuestionPaper/CreateQuestion/QuestionFormPreview";
import AdminFeedback from "./pages/Admin/AdminFeedback";
import AdminCourse from "./pages/Admin/AdminCourse";
import AdminCourseDetails from "./pages/Admin/AdminCourseDetails";
import AdminCourseVideo from "./pages/Admin/AdminCourseVideo";
import { ParentProfile } from "./pages/Profile/ParentProfile";
import ChildProgress from "./pages/Profile/ChildProgress";
import { Investor } from "./pages/Investor/Investor";
import Settings from "./pages/Settings/Settings";
import MyLearning from "./pages/MyLearning/MyLearning";
import Dashboard from "./pages/Dashboard/StudentDashboard";
import TeacherDashboard from "./pages/Dashboard/TeacherDashboard";
import Messages from "./pages/Message/Message";
import PurchasesHistory from "./pages/PurchaseHistory/PurchaseHistory";
import ProtectedRoute from "./services/ProtectedRoute";
import VerifyEmail from "./pages/EmailVerify/EmailVerify";
import LecturePage from "./pages/Course/LectureDetails";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/forgot-password" element={<ResetPassWordEmail />} />
        <Route path="/signup-confirmation" element={<LoginPopUp />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route
          path="/reset-password/:token"
          element={
            <ProtectedRoute>
              <ResetPassWord />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                {/* All */}
                <Route path="/" element={<Home />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
                <Route
                  path="/copyright-notification"
                  element={<CopyrightNotification />}
                />
                <Route path="/course/:courseId" element={<Course />} />
                <Route path="/open-course/:courseId" element={<OpenCourse />} />
                <Route
                  path="/course/:courseId/lecture/:lectureId"
                  element={<LecturePage />}
                />

                <Route
                  path="/edit-profile"
                  element={
                    <ProtectedRoute>
                      <EditProfile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/notification"
                  element={
                    <ProtectedRoute>
                      <Notification />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/wishlist"
                  element={
                    <ProtectedRoute>
                      <Wishlist />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/cart"
                  element={
                    <ProtectedRoute>
                      <Cart />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/qr-code"
                  element={
                    <ProtectedRoute>
                      <QRCodeScanner />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/setting"
                  element={
                    <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/learning"
                  element={
                    <ProtectedRoute>
                      <MyLearning />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/student-dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/message"
                  element={
                    <ProtectedRoute>
                      <Messages />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/purchases-history"
                  element={
                    <ProtectedRoute>
                      <PurchasesHistory />
                    </ProtectedRoute>
                  }
                />

                {/* Teacher and Instructor allowedRoles={["teacher", "instructor"]} */}
                <Route
                  path="/course-info"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CreateCourseInfo />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/course-desc"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CourseDescriptionForm />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/teacher-dashboard"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <TeacherDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/course-testVideo"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CourseVideoTest />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/course-content"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CourseContent />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/course-landingPage"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CourseLandingPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/course-price"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CoursePrice />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/course-preview"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <CreateCoursePreview />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/question-form"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <QuestionForm />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/question-form-preview"
                  element={
                    <ProtectedRoute allowedRoles={["teacher", "instructor"]}>
                      <QuestionFormPreview />
                    </ProtectedRoute>
                  }
                />

                {/* Parents allowedRoles={["parent"]}*/}
                <Route
                  path="/parent-profile"
                  element={
                    <ProtectedRoute allowedRoles={["parent"]}>
                      <ParentProfile />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/child-progress"
                  element={
                    <ProtectedRoute allowedRoles={["parent"]}>
                      <ChildProgress />
                    </ProtectedRoute>
                  }
                />

                {/*Admin  AdminallowedRoles={["admin"]} */}
                <Route
                  path="/home-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminHome />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/students-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminStudents />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/teacher-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminTeacher />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/feedback-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminFeedback />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/billing-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminBillig />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/courses-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminCourse />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/courses-details-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminCourseDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/courses-video-admin"
                  element={
                    <ProtectedRoute allowedRoles={["admin"]}>
                      <AdminCourseVideo />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
